import i18next from 'i18next';

export const privacidadeCurriculo = function () {
    "use strict";

    var $divModal = '#modal-privacidade';
    var $modal = body.find($divModal);
    var privacidadeID = body.find('#CurriculoPrivacidade').val();

    var _limpaSelecao = function () {
        $modal.find('.btn-group-justified').find('label').removeClass('btn-primary').removeClass('active');
    }
    var _setSelecao = function (privID) {
        _limpaSelecao();
        var input = $modal.find('input[name=privacidade][value="' + privID + '"]');
        input.prop('checked', true);
        input.parent('label').addClass('btn-primary');
    }

    var _salvar = function (tipo) {
        swal({
            title: i18next.t('privacidadeAlterar'),
            html: i18next.t('privacidadeAlterarDesc'),
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: i18next.t('btnSimAlterar'),
            cancelButtonText: i18next.t('btnCancelar'),
            closeOnConfirm: true
        }, function (isConfirm) {
            if (isConfirm) {
                window.global.loaderFull.show();
                $.ajax({
                    type: "POST",
                    url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/SavePrivacidade', cache: false,
                    data: { tipo: tipo },
                    success: function (data) {
                        if (data.success == 1) {
                            window.location.reload();
                        }
                        else {
                            swal("", data.error, "error");
                            window.global.loaderFull.hide();
                        }

                    },
                    error: function () {
                        window.global.loaderFull.hide();
                        swal("", i18next.t('erroServidor'), "error");
                    }
                });
            } else {
                _setSelecao(privacidadeID);
            }
        });
    };


    var _abrir = function () {
        _setSelecao(privacidadeID);

        $modal.modal();
    };


    var init = function () {

        $modal.find('input[name=privacidade]').on('change', function (e) {
            _limpaSelecao();
            var _this = $(this);
            _this.parent('label').addClass('btn-primary');
            var tipo = _this.val();
            if (privacidadeID != tipo) {
                _salvar(_this.val());
            }
        });

        body.find('.btn-privacidade').on('click', function (e) {
            _abrir();
            e.preventDefault();
        });

    }

    return init();
};

